module.exports = __webpack_public_path__ + "static/img/gpt76.8d0b653e.png";